export default __webpack_public_path__ + "static/media/Inca-Logo-Dark.48ff3b3f.svg";